import { useMemo } from 'react';
import { randomInteger } from 'src/utils/numbers';
import { DISPLAYED_ACTIVITIES } from '../constants';
import { useActivitiesStats } from '../hooks/useActivitiesStats';

export const useRandomActivity = (initialInterval: number) => {
  const { stats, statsDifference } = useActivitiesStats(initialInterval);

  const activity = useMemo(() => {
    if (!stats || !statsDifference) return null;

    const nonZeroActivities = DISPLAYED_ACTIVITIES.filter(
      a => stats[a.statsField] || statsDifference[a.statsField],
    );

    if (nonZeroActivities.length === 0) return null;

    const randomIndex = randomInteger({ min: 0, max: nonZeroActivities.length });
    return nonZeroActivities[randomIndex];
  }, [stats, statsDifference]);

  return useMemo(() => {
    if (!activity || !stats || !statsDifference) return null;

    return {
      ...activity,
      stat: stats[activity.statsField],
      statDifference: statsDifference[activity.statsField],
    };
  }, [activity, stats, statsDifference]);
};
